import React from 'react'
import WikipediaPage from './WikipediaPage'
import DataTag from './DataTag'

import '../App.css'
import '../styles/container.scss'
import '../styles/main.scss'
import '../styles/neighborhood.scss'
import '../styles/mapkey.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function NeighborhoodFinder(props){
    const panelStyle = () => {
        if (props.panel.neighborhood){
            return {
                position: 'absolute',
                zIndex: '1',
                height: '73vh',
                width: '23em',
            }
        }
    }
    const contentStyle = () => {
        if (props.panel.neighborhood){
            return {
                overflowY: 'scroll',
                height: '90%'
            }
        }
    }


    //cycle through list and map into clickable buttons with ref links
    //stick with old font-icons method - does not work well as buttons
    return (
            <div className="component" style={panelStyle()}>
                <div className="card-header">
                    <div className="header-front">
                        <FontAwesomeIcon icon={['fa', 'map-marker-alt']} size="2x" className="font-awesome-spacing"/>
                        <h2 className="text-header">Neighborhood</h2>
                    </div>
                        <button id="neighborhood" onClick={props.expandClick} className="expand-icon">
                            {props.panel.neighborhood ? 
                             <FontAwesomeIcon icon={['fa', 'minus']} className="font-awesome-win"/> :
                             <FontAwesomeIcon icon={['far', 'window-maximize']} className="font-awesome-win"/>
                            }
                        </button>
                </div>
                <div className="card-content" style={contentStyle()}>
                    <DataTag 
                        heading1={"Borough"} 
                        content1={props.borough === undefined ? 'N/A' : props.borough} 
                        heading2={"Neighborhood"}
                        content2={props.neighborhood === undefined || props.neighborhood === '' ? 'N/A' : props.neighborhood}
                    />
                    <WikipediaPage wiki = {props.wiki}/>      
                </div>

            </div>
    )
}
